import axios from 'axios';
import tracksData from '../data/tracks.json';

const API_URL = process.env.REACT_APP_API_URL
const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE === 'True'

const TrackService = {
    getAllTracks: async () => {
        try {
            if (STATIC_WEBSITE) {
                return tracksData;
            } else {
                const response = await axios.get(`${API_URL}/tracks/`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching tracks:', error);
            throw error;
        }
    },
};

export default TrackService;